import { FE_SEO_DISCOVER_HEAVY_GATING_042425 } from "@faire/retailer-settings/FE_SEO_DISCOVER_HEAVY_GATING_042425";
import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

import { useIsLoggedOutOrganicDiscoverPage } from "../lib/useIsLoggedOutOrganicDiscoverPage";

export const useSettingSeoDiscoverHeavyGate = (): boolean => {
  const setting = useSetting(FE_SEO_DISCOVER_HEAVY_GATING_042425);
  const isEligible = useIsLoggedOutOrganicDiscoverPage();
  return isEligible && setting;
};

export const useAssignSettingSeoDiscoverHeavyGate = () =>
  useAssignSetting(FE_SEO_DISCOVER_HEAVY_GATING_042425);
